import styled from 'styled-components'
import { InnerBox } from '../../../components/UI'
import verefied from '../../../assets/icons/verification.svg'

const Styled = {
  Row: styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px;
    padding-top: 8px;
    gap: 16px 0;
  `,
  Col: styled.div`
    padding: 0 8px;
    width: 50%;
    position: relative;
    z-index: 1;

    @media (max-width: 767px) {
      width: 100%;
      padding: 0 8px;

      & + & {
        margin-top: 16px;
      }
    }

    &.about {
      width: 100%;
      margin-top: 16px;
    }

    &.social {
      margin-top: 16px;
    }

    &.controls {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      padding-top: 16px;
      border-top: 1px solid rgba(255, 255, 255, 0.08);

      button + button {
        margin-left: 0;
      }

      @media (max-width: 767px) {
        width: 100%;
        flex-direction: column;
        gap: 12px;

        button + button {
          margin-left: 0;
          margin-top: 0;
        }
      }
    }
  `,
  StyledInnerBox: styled(InnerBox)`
    height: 100%;
    border-radius: 12px;
    box-shadow:
      0 4px 20px rgba(0, 0, 0, 0.15),
      0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.1) 50%,
        transparent 100%
      );
    }
  `,
  Content: styled.div`
    .logos {
      display: flex;
      justify-content: center;
      margin: 0 -10px;

      .logo {
        padding: 0 10px;
        width: 33.3333%;
        display: flex;
        justify-content: center;

        img {
          display: block;
          max-width: 100%;
        }
      }
    }

    .qr {
      display: flex;
      justify-content: center;

      img {
        min-width: 100%;
      }
    }

    .nickname {
      text-align: center;
      font-size: 24px;
      font-weight: 700;
      margin: 0 0 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      letter-spacing: 0.5px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;

      svg {
        position: relative;
        top: -4px;
        margin-left: 8px;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
      }
    }

    .username {
      text-align: center;
      font-weight: 600;
      font-size: 18px;
      margin: 0 0 8px;
      color: rgba(255, 255, 255, 0.9);
      letter-spacing: 0.3px;
    }

    .role {
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 8px;
    }

    .sectionTitle {
      font-weight: 600;
      font-size: 22px;
      margin: 0 0 20px;
      color: rgba(255, 255, 255, 0.95);
      letter-spacing: 0.5px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 40px;
        height: 2px;
        background: linear-gradient(
          90deg,
          #eda211 0%,
          rgba(237, 162, 17, 0.5) 100%
        );
        border-radius: 1px;
      }

      &.next {
        margin: 20px 0;
      }

      &.withSwitcher {
        display: flex;
        align-items: center;
      }
      &.moreInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &::after {
          display: none;
        }
      }
      .moreInfo {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 0.03em;
        text-decoration-line: underline;
        text-transform: capitalize;
        text-shadow: 0 4px 4px rgb(0 0 0 / 25%);
        cursor: pointer;
        transition: all 0.3s ease;
        color: #eda211;
      }

      strong {
        font-weight: bold;
      }
    }

    .dataRow {
      font-size: 15px;
      display: flex;
      align-items: flex-start;
      padding: 12px 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.05);

      &:last-child {
        border-bottom: none;
      }

      @media (min-width: 992px) and (max-width: 1199px) {
        flex-direction: column;
      }

      &.center {
        justify-content: center;
      }

      & + .dataRow {
        margin-top: 0;
      }

      > div {
        &:first-child {
          min-width: 100px;
          padding-right: 20px;
          flex-shrink: 0;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.8);
          text-transform: uppercase;
          font-size: 13px;
          letter-spacing: 0.5px;
        }

        &:last-child {
          color: rgba(255, 255, 255, 0.95);
          font-weight: 500;
        }
      }

      &.row-type {
        display: block;
        padding: 16px 0;

        > div {
          &:first-child {
            margin-bottom: 8px;
            padding-right: 0;
            font-size: 14px;
          }
        }
      }
    }
  `,
  AvatarHolder: styled.div`
    width: 120px;
    height: 120px;
    margin: 0 auto 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  Avatar: styled.div`
    width: 120px;
    height: 120px;
    border-radius: 16px;
    overflow: hidden;
    background: ${props =>
      props.image
        ? `#eee url(${props.image}) no-repeat center center`
        : '#eee'};
    background-size: cover;
    border: ${props => (!!props.pro ? '3px solid #eda211' : 'none')};
    box-shadow:
      0 8px 25px rgba(0, 0, 0, 0.3),
      0 2px 8px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 50%
      );
      border-radius: 16px;
      pointer-events: none;
    }

    &.top-gamer {
      border: 3px solid #eda211;
      box-shadow:
        0 8px 25px rgba(237, 162, 17, 0.3),
        0 2px 8px rgba(237, 162, 17, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }
  `,
  VerifiedStatus: styled.div`
    width: 38px;
    height: 38px;
    position: absolute;
    bottom: -8px;
    right: -8px;
    content: url(${verefied});
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
    z-index: 2;
  `,

  About: styled.div`
    font-size: 14px;
    padding-left: 30px;
    position: relative;

    svg {
      position: absolute;
      top: 0;
      left: 0;
    }
  `,
}

export default Styled
